<script setup>
import { onBeforeMount, computed, ref } from "vue"
import { useStore } from "vuex"
import {
  CheckCircleIcon,
  MinusIcon,
  DocumentTextIcon,
  ChevronRightIcon,
} from "@heroicons/vue/20/solid"
import { apiUrl } from "@common/js/helpers"
import { useI18n } from "vue-i18n"
import qs from "qs"

const { t } = useI18n()
const store = useStore()
const loading = ref(true)

const tiers = [
  {
    name: "Faire seul",
    id: "tier-alone",
    href: "#",
    priceLow: "2€",
    priceHigh: "3€",
    description: "Quis suspendisse ut fermentum neque vivamus non tellus.",
    mostPopular: false,
  },
  {
    name: "Projetsolaire",
    id: "tier-projetsolaire",
    href: "#",
    priceLow: "1€",
    priceHigh: "2€",
    description: "Quis eleifend a tincidunt pellentesque. A tempor in sed.",
    mostPopular: true,
  },
  {
    name: "Grands groupes",
    id: "tier-competition",
    href: "#",
    priceLow: "2€",
    priceHigh: "5€+",
    description:
      "Orci volutpat ut sed sed neque, dui eget. Quis tristique non.",
    mostPopular: false,
  },
]
const sections = [
  {
    name: "Montant du devis",
    features: [
      {
        name: "Fourchette de prix",
        tiers: {
          "Faire seul": "2 €/Wc - 3 €Wc",
          Projetsolaire: "1 €/Wc - 2 €Wc",
          "Grands groupes": "3 €/Wc - 5+ €/Wc",
        },
      },
      {
        name: "Zéro commissions de vente",
        tiers: {
          "Faire seul": true,
          Projetsolaire: true,
          "Grands groupes": false,
        },
      },
      {
        name: "Mise en concurrence",
        tiers: {
          "Faire seul": false,
          Projetsolaire: true,
          "Grands groupes": false,
        },
      },
    ],
  },
  {
    name: "Qualité de l'installation",
    features: [
      {
        name: "Zéro sous-traitance",
        tiers: {
          "Faire seul": true,
          Projetsolaire: true,
          "Grands groupes": false,
        },
      },
      {
        name: "Assurance décénnale",
        tiers: {
          "Faire seul": false,
          Projetsolaire: true,
          "Grands groupes": true,
        },
      },
      {
        name: "Puissance du matériel",
        tiers: {
          "Faire seul": "375 Wc - 400 Wc",
          Projetsolaire: "375 Wc - 500 Wc",
          "Grands groupes": "330 Wc - 375 Wc",
        },
      },
    ],
  },
  {
    name: "Assistance",
    features: [
      {
        name: "Étude indépendante",
        tiers: {
          "Faire seul": true,
          Projetsolaire: true,
          "Grands groupes": false,
        },
      },
      {
        name: "Suivi administratif",
        tiers: {
          "Faire seul": false,
          Projetsolaire: true,
          "Grands groupes": true,
        },
      },
      {
        name: "Tiers contrôle",
        tiers: {
          "Faire seul": false,
          Projetsolaire: true,
          "Grands groupes": false,
        },
      },
    ],
  },
]
let installers
onBeforeMount(async () => {
  let params = { size: 6 }
  try {
    installers = (
      await axios("/installer-directory/search", {
        params,
        paramsSerializer: (params) => {
          return qs.stringify(params)
        },
      })
    ).data.items
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="bg-transparent py-20 sm:pt-20 sm:pb-2">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div
        class="mx-auto grid max-w-2xl grid-cols-1 lg:mx-0 lg:max-w-none lg:grid-cols-[60%_35%] gap-[5%]"
      >
        <div>
          <p
            class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
          >
            {{ $t("home.why-us.title") }}
          </p>
          <p class="mt-6 text-base leading-7 text-gray-600">
            {{ $t("home.why-us.description-1") }}
          </p>
          <p class="mt-0 mb-4 text-base leading-7 text-gray-600">
            {{ $t("home.why-us.description-2") }}
          </p>
          <!--
          <dl
            class="pt-4 grid grid-cols-1 gap-x-8 gap-y-10 text-base leading-7 text-gray-600 sm:grid-cols-2 lg:gap-y-16"
          >
            <div
              v-for="feature in features"
              :key="feature.name"
              class="relative pl-9"
            >
              <dt class="font-semibold text-gray-900">
                <CheckCircleIcon
                  class="absolute left-0 top-1 h-5 w-5 text-black"
                  aria-hidden="true"
                />
                {{ feature.name }}
              </dt>
              <dd class="mt-2">{{ feature.description }}</dd>
            </div>
          </dl>
          -->
          <!--Table start here-->
          <div class="mx-auto max-w-7xl">
            <!-- xs to lg -->
            <!--mobile-->
            <div class="mx-auto max-w-md space-y-4 sm:mt-8 lg:hidden">
              <section
                v-for="tier in tiers"
                :key="tier.id"
                :class="[
                  tier.mostPopular
                    ? 'rounded-xl bg-gray-400/5 ring-1 ring-inset ring-gray-200'
                    : '',
                  'p-8',
                ]"
              >
                <h3
                  :id="tier.id"
                  class="font-semibold leading-6 text-gray-900 text-center"
                >
                  {{ tier.name }}
                </h3>
                <!--<p class="mt-2 flex items-baseline gap-x-1 text-gray-900">
                  <span class="text-xl font-bold">{{ tier.priceLow }}</span>
                  <span class="text-sm font-semibold">/Wc</span>
                  -
                  <span class="text-xl font-bold">{{ tier.priceHigh }}</span>
                  <span class="text-sm font-semibold">/Wc</span>
                </p>
                <a :href="tier.href" :aria-describedby="tier.id" :class="[tier.mostPopular ? 'bg-indigo-600 text-white hover:bg-indigo-500' : 'text-indigo-600 ring-1 ring-inset ring-indigo-200 hover:ring-indigo-300', 'mt-8 block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600']">Buy plan</a>-->
                <ul
                  role="list"
                  class="mt-2 space-y-2 text-sm leading-6 text-gray-900"
                >
                  <li v-for="section in sections" :key="section.name">
                    <ul role="list" class="space-y-2">
                      <template
                        v-for="feature in section.features"
                        :key="feature.name"
                      >
                        <li
                          v-if="feature.tiers[tier.name]"
                          class="flex gap-x-3"
                        >
                          <CheckCircleIcon
                            class="h-6 w-5 flex-none text-black"
                            aria-hidden="true"
                          />
                          <span>
                            {{ feature.name }}
                            {{ " " }}
                            <span
                              v-if="
                                typeof feature.tiers[tier.name] === 'string'
                              "
                              class="text-sm leading-6 text-gray-700"
                              >({{ feature.tiers[tier.name] }})</span
                            >
                          </span>
                        </li>
                      </template>
                    </ul>
                  </li>
                </ul>
              </section>
            </div>

            <!-- lg+ -->
            <!--desktop-->
            <div class="isolate hidden lg:block">
              <div class="relative -mx-2">
                <div
                  v-if="tiers.some((tier) => tier.mostPopular)"
                  class="absolute inset-x-4 inset-y-0 -z-10 flex"
                >
                  <div
                    class="flex w-1/4 px-4"
                    aria-hidden="true"
                    :style="{
                      marginLeft: `${
                        (tiers.findIndex((tier) => tier.mostPopular) + 1) * 25
                      }%`,
                    }"
                  >
                    <div
                      class="w-full rounded-t-xl border-x border-t border-gray-900/10 bg-gray-400/5"
                    />
                  </div>
                </div>
                <table
                  class="w-full table-fixed border-separate border-spacing-x-0 text-left"
                >
                  <colgroup>
                    <col class="w-1/4" />
                    <col class="w-1/4" />
                    <col class="w-1/4" />
                    <col class="w-1/4" />
                  </colgroup>
                  <thead>
                    <tr>
                      <td />
                      <th
                        v-for="tier in tiers"
                        :key="tier.id"
                        scope="col"
                        class="px-2 pt-2 xl:px-2 xl:pt-4"
                      >
                        <div
                          class="font-semibold leading-7 text-gray-900 text-center"
                        >
                          {{ tier.name }}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--<tr>
                      <th scope="row"><span class="sr-only">Price</span></th>
                      <td v-for="tier in tiers" :key="tier.id" class="px-6 pt-2 xl:px-4">
                        <div class="flex items-baseline gap-x-1 text-gray-900">
                          <span class="text-xl font-bold">{{ tier.priceLow }}</span>
                          <span class="text-sm font-semibold">/Wc</span>
                          -
                          <span class="text-xl font-bold">{{ tier.priceHigh }}</span>
                          <span class="text-sm font-semibold">/Wc</span>
                        </div>
                        <a :href="tier.href" :class="[tier.mostPopular ? 'bg-indigo-600 text-white hover:bg-indigo-500' : 'text-indigo-600 ring-1 ring-inset ring-indigo-200 hover:ring-indigo-300', 'mt-8 block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600']">Buy plan</a>
                      </td>
                    </tr>-->
                    <template
                      v-for="(section, sectionIdx) in sections"
                      :key="section.name"
                    >
                      <tr>
                        <th
                          scope="colgroup"
                          colspan="4"
                          :class="[
                            sectionIdx === 0 ? 'pt-2' : 'pt-8',
                            'pb-0 text-sm font-semibold leading-6 text-gray-900',
                          ]"
                        >
                          {{ section.name }}
                          <div
                            class="-ml-8 absolute inset-x-8 mt-0 h-px bg-gray-900/10"
                          />
                          <!--this is horizontal gray line -->
                        </th>
                      </tr>
                      <tr
                        v-for="feature in section.features"
                        :key="feature.name"
                      >
                        <th
                          scope="row"
                          class="py-4 text-sm font-normal leading-6 text-gray-900"
                        >
                          {{ feature.name }}
                          <div
                            class="-ml-8 absolute inset-x-8 mt-4 h-px bg-gray-900/5"
                          />
                          <!--this is horizontal gray line -->
                        </th>
                        <td
                          v-for="tier in tiers"
                          :key="tier.id"
                          class="px-6 py-0 xl:px-8"
                        >
                          <div
                            v-if="typeof feature.tiers[tier.name] === 'string'"
                            class="text-center text-sm leading-6 text-gray-700"
                          >
                            {{ feature.tiers[tier.name] }}
                          </div>
                          <template v-else>
                            <CheckCircleIcon
                              v-if="feature.tiers[tier.name] === true"
                              class="mx-auto h-5 w-5 text-black"
                              aria-hidden="true"
                            />
                            <MinusIcon
                              v-else
                              class="mx-auto h-5 w-5 text-gray-400"
                              aria-hidden="true"
                            />
                            <span class="sr-only"
                              >{{
                                feature.tiers[tier.name] === true
                                  ? "Included"
                                  : "Not included"
                              }}
                              in {{ tier.name }}</span
                            >
                          </template>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--Table end here-->
        </div>
        <div
          v-if="!loading"
          class="hidden lg:block max-w-xl md:max-w-none md:w-full mx-auto relative"
          data-aos="zoom-y-out"
        >
          <div class="w-[210%] absolute md:grid grid-cols-3 gap-5">
            <router-link
              v-for="(item, index) in installers"
              :key="index"
              to="/lead-flow"
              :class="[
                [1, 4].includes(index) ? '-mt-20' : '',
                'h-96 relative border rounded-lg shadow-xl hover:scale-105 cursor-pointer transition',
              ]"
            >
              <div class="absolute py-6 px-5 z-30 w-full">
                <img
                  v-if="item.logo"
                  :src="apiUrl(item.logo.thumbnail)"
                  class="w-10 rounded"
                />
              </div>
              <div
                class="absolute bottom-5 flex items-start gap-1 px-5 py-4 z-30"
              >
                <p class="font-semibold text-white">
                  {{ $t("home.why-us.start-with-this-installer") }}
                </p>
                <ChevronRightIcon class="w-5 text-white mt-1" />
              </div>
              <img
                class="absolute h-full w-full rounded-lg -z-10 inset-0 object-cover object-[left]"
                :src="
                  item.images[0]
                    ? apiUrl(item.images[0].original)
                    : 'https://images.ctfassets.net/1b6f0wuf6ave/7KT0xPFtfGiE6tF5i3VWZv/fd141bf01dce91e465c389e99d32d895/installer-mosaic.jpg'
                "
              />
              <div
                :style="{
                  backgroundColor:
                    item.theme.backgroundColourPrimary == 'rgb(255 255 255)'
                      ? 'rgba(71, 71, 71)'
                      : item.theme.backgroundColourPrimary,
                }"
                :class="`absolute inset-0 pointer-events-none rounded-lg z-20 mask`"
              ></div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mask {
  mask-image: linear-gradient(0deg, #000 15%, rgba(0, 0, 0, 0.5) 54.75%);
  -webkit-mask-image: linear-gradient(
    0deg,
    #000 15%,
    rgba(0, 0, 0, 0.5) 54.75%
  );
}
</style>
